export default __webpack_public_path__ + "static/JSUL-f3c68f60f0c329aa1b288c73a1dff357.mp4";